module.exports = __webpack_public_path__ + "img/Grace-Hopper-Conference-2019.f8fc4462.jpg";